/**
 * StretchedClusterPicklist — dropdown for selecting a stretched cluster (A or B) for a given cluster.
 *
 * Used in EditServerRolesModal to assign hosts to stretched clusters.
 * Accepts a clusterName prop to look up available domains from the selector.
 *
 * FR: FR-014
 */

import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import Dropdown from 'core/elements/dropdown'
import { stretchedClustersByClusterSelector } from '../selectors'

interface Props {
  clusterName?: string
  value?: string
  onChange?: (value: string) => void
  disabled?: boolean
  [key: string]: any
}

export default function StretchedClusterPicklist({
  clusterName,
  value,
  onChange,
  disabled,
  ...rest
}: Props) {
  const stretchedClustersByCluster = useSelector(stretchedClustersByClusterSelector)

  const { items, hasDomains } = useMemo(() => {
    const pair = clusterName ? stretchedClustersByCluster[clusterName] : null
    const domainItems = []
    if (pair?.domainA)
      domainItems.push({ label: pair.domainA.name, value: String(pair.domainA.id) })
    if (pair?.domainB)
      domainItems.push({ label: pair.domainB.name, value: String(pair.domainB.id) })
    return { items: domainItems, hasDomains: domainItems.length > 0 }
  }, [clusterName, stretchedClustersByCluster])

  return (
    <Dropdown
      items={items}
      value={value}
      onChange={onChange}
      disabled={disabled || !clusterName || !hasDomains}
      placeholder={'Select domain'}
      {...rest}
    />
  )
}
